import * as yup from 'yup'

import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
} from 'reactstrap'
import { FaPencilAlt, FaSave, FaTrash } from 'react-icons/fa'
import React, { useState } from 'react'

import BuscadorTablas from 'components/Buscador/BuscadorTabla'
import PaginaPorDefecto from './Default'
import TarjetaContenido from 'components/TarjetaContenido/TarjetaContenido'
import { useCaracteristica } from 'hooks/useCaracteristicas'
import { useFactor } from 'hooks/useFactor'
import { useFormik } from 'formik'
import { useToggle } from 'hooks/useToggle'
import uuid from 'uuid/v4'

// import Select from 'react-select'

const initialValues = {
  identificador: '',
  nombre: '',
  descripcion: '',
  indicadores: '',
  peso: '',
  factor: '',
  // tipo_autoevaluacion: [],
}

const caracteristicaSchema = yup.object().shape({
  identificador: yup.string().required('Este campo es requerido'),
  nombre: yup.string().required('Este campo es requerido'),
  descripcion: yup.string().required('Este campo es requerido'),
  indicadores: yup.string().required('Este campo es requerido'),
  peso: yup.string().required('Este campo es requerido'),
  factor: yup.string().required('Este campo es requerido'),
  // tipo_autoevaluacion: yup
  //   .array()
  //   .of(
  //     yup.object().shape({
  //       label: yup.string(),
  //       value: yup.string(),
  //     }),
  //   )
  //   .required('Este campo es requerido')
  //   .min(1, 'Este campo es requerido'),
})

export default function Caracteristica() {
  const { open, onToggle } = useToggle()
  const [caracteristicaEdit, setCaracteristicaEdit] = useState(null)
  const [buscar, setBuscar] = useState('')
  const {
    obtenerCaracteristicas,
    handleEliminarCaracteristica,
    handleActualizarCaracteristica,
    handleCrearCaracteristica,
    handleBuscarCaracteristica,
  } = useCaracteristica(onToggle)
  const { obtenerFactores } = useFactor(onToggle)
  const { data: caracteristicas } = obtenerCaracteristicas(buscar)
  const { data: factores } = obtenerFactores(buscar)
  // const { data: tipoautoevaluaciones } = obtenerTipoAutoevaluaciones(buscar)

  const {
    handleChange,
    values,
    handleSubmit,
    errors,
    // setFieldValue,
  } = useFormik({
    enableReinitialize: true,
    validationSchema: caracteristicaSchema,
    initialValues: {
      ...initialValues,
      ...caracteristicaEdit,
    },

    onSubmit: async (values, acciones) => {
      // const datos = {
      //   ...values,
      //   tipo_autoevaluacion: values.tipo_autoevaluacion?.map(
      //     (item) => item.value,
      //   )[0],
      // }
      if (caracteristicaEdit) {
        handleActualizarCaracteristica({
          values,
          acciones,
          id: caracteristicaEdit.id,
        })
      } else {
        handleCrearCaracteristica(values, acciones)
      }
    },
  })

  const onClosedModal = () => {
    setCaracteristicaEdit(null)
  }

  return (
    <PaginaPorDefecto titulo='Característica'>
      {/* {JSON.stringify(errors.tipoautoevaluacion)} */}
      <Modal
        isOpen={open}
        toggle={onToggle}
        size='lg'
        unmountOnClose
        onClosed={onClosedModal}
      >
        <ModalHeader toggle={onToggle}>
          {caracteristicaEdit ? 'Editar' : 'Crear'} Caracteristica
        </ModalHeader>
        <ModalBody>
          <form className='form-horizontal col-xs-12' onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Identificador</Label>
                  <Input
                    type='text'
                    name='identificador'
                    value={values.identificador}
                    onChange={handleChange}
                    placeholder='Ingrese identificador'
                    invalid={!!errors.identificador}
                  />
                  <div className='invalid-feedback'>{errors.nombre}</div>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label>Peso</Label>
                  <Input
                    type='number'
                    name='peso'
                    value={values.peso}
                    onChange={handleChange}
                    placeholder='Ingrese peso'
                    invalid={!!errors.peso}
                  />
                  <div className='invalid-feedback'>{errors.peso}</div>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label>Característica</Label>
                  <Input
                    type='text'
                    name='nombre'
                    value={values.nombre}
                    onChange={handleChange}
                    placeholder='Ingrese característica'
                    invalid={!!errors.nombre}
                  />
                  <div className='invalid-feedback'>{errors.nombre}</div>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label>Indicadores</Label>
                  <Input
                    type='number'
                    name='indicadores'
                    value={values.indicadores}
                    onChange={handleChange}
                    placeholder='Ingrese indicadores'
                    invalid={!!errors.indicadores}
                  />
                  <div className='invalid-feedback'>{errors.indicadores}</div>
                </FormGroup>
              </Col>

              <Col md={12}>
                <FormGroup>
                  <Label>Descripción</Label>
                  <Input
                    type='textarea'
                    name='descripcion'
                    value={values.descripcion}
                    onChange={handleChange}
                    placeholder='Ingrese descripción'
                    invalid={!!errors.descripcion}
                  />
                  <div className='invalid-feedback'>{errors.descripcion}</div>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label>Factor</Label>
                  <Input
                    type='select'
                    name='factor'
                    value={values.factor}
                    onChange={handleChange}
                    placeholder='Ingrese factor'
                    invalid={!!errors.factor}
                  >
                    <option value=''>Seleccione...</option>
                    {factores?.results.map((factor) => (
                      <option key={uuid()} value={factor.id}>
                        {factor.identificador}
                      </option>
                    ))}
                  </Input>
                  <div className='invalid-feedback'>{errors.factor}</div>
                </FormGroup>
              </Col>

              {/* <Col md={6}>
                <FormGroup>
                  <Label>Tipo Autoevaluación</Label>
                  <Select
                    styles={{
                      container: (provided) => {
                        return {
                          ...provided,
                          borderRadius: '5px',
                          ...(errors.tipo_autoevaluacion && {
                            border: '1px solid red',
                          }),
                        }
                      },
                    }}
                    selectOption={tipoautoevaluaciones?.results.filter(
                      (tipoautoevaluacion) => {
                        // debugger
                        console.log(values)
                        if (
                          values.tipo_autoevaluacion === tipoautoevaluacion.id
                        ) {
                          return {
                            value: tipoautoevaluacion.id,
                            label: tipoautoevaluacion.nombre,
                          }
                        }
                        return []
                      },
                    )}
                    onChange={(value) =>
                      setFieldValue('tipo_autoevaluacion', value)
                    }
                    isMulti
                    options={tipoautoevaluaciones?.results.map(
                      (tipoautoevaluacion) => ({
                        value: tipoautoevaluacion.id,
                        label: tipoautoevaluacion.nombre,
                      }),
                    )}
                  />
                  <div className='text-danger' style={{ fontSize: '80%' }}>
                    {errors.tipo_autoevaluacion}
                  </div>
                </FormGroup>
              </Col> */}

              <div className='form-group'>
                <label
                  className='col-md-12 control-label'
                  htmlFor='singlebutton'
                ></label>
                <div className='col-md-12'>
                  <Button className='mb-3' color='primary' type='submit'>
                    {caracteristicaEdit ? 'Editar' : 'Guardar'}
                  </Button>
                </div>
              </div>
            </Row>
          </form>
        </ModalBody>
      </Modal>

      <TarjetaContenido
        titulo='Listar Caracteristica'
        component={
          <Button outline color='primary' onClick={onToggle}>
            <FaSave />
          </Button>
        }
      >
        <BuscadorTablas
          valor={buscar}
          onChange={setBuscar}
          onBuscar={handleBuscarCaracteristica}
        />
        {caracteristicas ? (
          <Table responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Identificador</th>
                <th>Caracteristica</th>
                <th>Descripción</th>
                <th>Factor</th>
                <th>Peso</th>
                <th>Indicadores</th>
                <th>acciones</th>
              </tr>
            </thead>
            <tbody>
              {caracteristicas.results.map((caracteristica, index) => (
                <tr key={uuid()}>
                  <th scope='row'>{index + 1}</th>
                  <td>{caracteristica.identificador}</td>
                  <td>{caracteristica.nombre}</td>
                  <td>{caracteristica.descripcion}</td>
                  <td>{caracteristica.factor__nombre}</td>
                  {/* <td>{caracteristica.tipo_auto__nombre}</td> */}
                  <td>{caracteristica.peso}</td>
                  <td>{caracteristica.indicadores}</td>
                  <td className='d-flex'>
                    <Button
                      outline
                      color='primary'
                      size='sm'
                      className='mr-1'
                      onClick={() => {
                        setCaracteristicaEdit(caracteristica)
                        onToggle()
                      }}
                    >
                      <FaPencilAlt />
                    </Button>{' '}
                    <Button
                      outline
                      color='danger'
                      size='sm'
                      onClick={() =>
                        handleEliminarCaracteristica(caracteristica)
                      }
                    >
                      <FaTrash />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <div>Loading...</div>
        )}
      </TarjetaContenido>
    </PaginaPorDefecto>
  )
}
